import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { LayoutContext } from '../../Context/LayoutContext';
import { API_URL } from '../../Config/constant';
import toast, { Toaster } from 'react-hot-toast';
import Loader from '../Common/Loader';

const validateImageSize = (file, callback) => {
  const img = new Image();
  const objectUrl = URL.createObjectURL(file);
  img.src = objectUrl;
  img.onload = () => {
    URL.revokeObjectURL(objectUrl);
    if (img.width <= 40 && img.height <= 40) {
      callback(true);
    } else {
      toast.error('Image must be less than or equal to 40x40 pixels.');
      callback(false);
    }
  };
};

export default function JobFunction() {
  const [jobFunctions, setJobFunctions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { apiToken } = useContext(LayoutContext);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [currentJobFunction, setCurrentJobFunction] = useState(null);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [newJobFunction, setNewJobFunction] = useState({
    name: '',
    icon: null,
  });

  useEffect(() => {
    if (apiToken) {
      jobFunctionList();
    }
  }, [apiToken]);

  const jobFunctionList = () => {
    setLoading(true);
    axios
      .post(
        `${API_URL}api/job-function/list`,
        {},
        {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        }
      )
      .then((response) => {
        const { data } = response?.data;
        setJobFunctions(data);
      })
      .catch((error) => {
        console.error('There was an error fetching the job functions!', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEdit = (id) => {
    const jobFunction = jobFunctions.find((jf) => jf.id === id);
    setCurrentJobFunction(jobFunction);
    setEditModalVisible(true);
  };

  const handleUpdate = () => {
    validateImageSize(currentJobFunction.icon, (isValid) => {
      if (!isValid) return;
      setLoading(true);
      const formData = new FormData();
      formData.append('name', currentJobFunction?.name);
      formData.append('icon', currentJobFunction?.icon);
      formData.append('status', currentJobFunction?.status);
      axios
        .post(`${API_URL}api/job-function/edit/${currentJobFunction.id}`, formData, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const { message } = response.data;
          jobFunctionList();
          toast.success(message || 'Job function updated successfully!');
          setEditModalVisible(false);
        })
        .catch((error) => {
          const { message } = error.response.data;
          console.error('There was an error updating the job function!', error);
          toast.error(message || 'Failed to update job function.');
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const updateStatus = (id, status) => {
    setLoading(true);
    axios
      .post(
        `${API_URL}api/job-function/update-status/${id}`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        }
      )
      .then((response) => {
        const { message } = response.data;
        jobFunctionList();
        toast.success(message || 'Status updated successfully!');
      })
      .catch((error) => {
        const { message } = error.response.data;
        console.error('There was an error updating the job function status!', error);
        toast.error(message || 'Failed to update status.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleStatusToggle = (id) => {
    const jobFunction = jobFunctions.find((jf) => jf.id === id);
    const newStatus = jobFunction.status === 1 ? 0 : 1;
    updateStatus(id, newStatus);
  };

  const handleDelete = (id) => {
    updateStatus(id, 90);
  };

  const handleAdd = () => {
    validateImageSize(newJobFunction.icon, (isValid) => {
      if (!isValid) return;
      setLoading(true);
      const formData = new FormData();
      formData.append('name', newJobFunction.name);
      formData.append('icon', newJobFunction.icon);

      axios
        .post(`${API_URL}api/job-function/add`, formData, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const { message } = response.data;
          jobFunctionList();
          toast.success(message || 'Job function added successfully!');
          setAddModalVisible(false);
        })
        .catch((error) => {
          const { message } = error.response.data;
          console.error('There was an error adding the job function!', error);
          toast.error(message || 'Failed to add job function.');
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return (
    <>
      <button
        className="btn btn-primary"
        onClick={() => setAddModalVisible(true)}
        style={{ marginBottom: '10px', padding: '13px' }}
      >
        Add Job Function
      </button>{' '}
      <div className="card ">
        {loading && <Loader />}
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table  custom-table  no-footer">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Icon</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th className="table-status-column">Action</th>
                </tr>
              </thead>
              <tbody>
                {jobFunctions.map((jobFunction, index) => (
                  <tr key={jobFunction.id}>
                    <td>{index + 1}</td>
                    <td>{jobFunction.icon ? <img src={jobFunction.icon} alt="icons" /> : '-'}</td>
                    <td>{jobFunction.name}</td>
                    <td>
                      <span
                        style={{
                          color: jobFunction.status === 1 ? 'green' : 'red',
                        }}
                      >
                        {jobFunction.status === 1 ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="table-status-column">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleEdit(jobFunction.id)}
                        style={{ padding: '.25rem .5rem' }}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleStatusToggle(jobFunction.id)}
                      >
                        <i className={`fas fa-${jobFunction.status === 1 ? 'times' : 'check'}`}></i>
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(jobFunction.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {editModalVisible && (
          <div className="customize_popup">
            <div
              className="modal fade show"
              style={{
                display: 'block',
                background: 'rgba(0, 0, 0, 0.5)',
              }}
              id="edit_job_function"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Edit Job Function
                    </h5>
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={() => setEditModalVisible(false)}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="col-md-12 p-0">
                      <div className="form-group">
                        <label htmlFor="jobFunctionName">Name</label>
                        <input
                          type="text"
                          id="jobFunctionName"
                          className="form-control"
                          value={currentJobFunction.name}
                          onChange={(e) =>
                            setCurrentJobFunction({
                              ...currentJobFunction,
                              name: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="jobFunctionIcon">Icon</label>
                        <input
                          type="file"
                          id="jobFunctionIcon"
                          className="form-control"
                          onChange={(e) =>
                            setCurrentJobFunction({
                              ...currentJobFunction,
                              icon: e.target.files[0],
                            })
                          }
                        />
                        <small className="form-text text-muted">
                          Image must be less than or equal to 40x40 pixels.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-add" onClick={handleUpdate}>
                      Update
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setEditModalVisible(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {addModalVisible && (
          <div className="customize_popup">
            <div
              className="modal fade show"
              style={{
                display: 'block',
                background: 'rgba(0, 0, 0, 0.5)',
              }}
              id="add_job_function"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Add Job Function
                    </h5>
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={() => setAddModalVisible(false)}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="col-md-12 p-0">
                      <div className="form-group">
                        <label htmlFor="newJobFunctionName">Name</label>
                        <input
                          type="text"
                          id="newJobFunctionName"
                          className="form-control"
                          value={newJobFunction.name}
                          onChange={(e) =>
                            setNewJobFunction({
                              ...newJobFunction,
                              name: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="newJobFunctionIcon">Icon</label>
                        <input
                          type="file"
                          id="newJobFunctionIcon"
                          className="form-control"
                          onChange={(e) =>
                            setNewJobFunction({
                              ...newJobFunction,
                              icon: e.target.files[0],
                            })
                          }
                        />
                        <small className="form-text text-muted">
                          Image must be less than or equal to 40x40 pixels.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-add" onClick={handleAdd}>
                      Add
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setAddModalVisible(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <Toaster />
      </div>
    </>
  );
}
